import React from "react";
import PeopleCard from "../components/people-card";
import "../styles/peopleGroup.css";
import { useTranslation } from 'react-i18next';

const PeopleGroup = ({ groupName, people }) => {
    const { t, i18n } = useTranslation("people");

    if (!people || people.length === 0) {
        return null;
    }

    const activeMembers = people.filter(person => person.is_active);

    if (activeMembers.length === 0) {
        return (<></>);
    }

    return (
        <div className="people-group">
            <h2 className="group-title">{t(`roles.plural.${groupName}`)}</h2>
            
            {activeMembers.length > 0 && (
                <div className="people-grid">
                    {activeMembers.map((person) => (
                        <div key={person.id} className="people-card-wrapper">
                            <PeopleCard
                                display_name={person.display_name}
                                image={person.image}
                                is_active={person.is_active}
                                role={person.bio}
                                groupImage={person.groupImage}
                            />
                        </div>
                    ))}
                </div>
            )}
            
        </div>
    );
};

export default PeopleGroup;
